// extracted by mini-css-extract-plugin
module.exports = {"case_desc":"CaseDesc_case_desc__1yQoz","main":"CaseDesc_main__TgMDo","empty":"CaseDesc_empty__1gFqb"};